import { SOCIALS } from "@/constants/socials";
import { GLYPHS } from "@/components/SocialIcons";

/**
 * Renders social buttons row.
 * variant: "dark" (on dark bg, footer) | "light" (on light bg, contact page)
 */
export default function SocialBar({ variant = "dark", size = "md", testIdPrefix = "social" }) {
  const px = size === "sm" ? "w-10 h-10" : "w-12 h-12";
  const iconSize = size === "sm" ? 16 : 18;
  const base = variant === "dark"
    ? "bg-white/[0.03] border border-white/10 text-white hover:bg-white/[0.08]"
    : "bg-[var(--bg-soft)] border border-black/5 text-[var(--ink)] hover:bg-white hover:shadow-md";
  return (
    <div className="flex flex-wrap gap-3">
      {SOCIALS.map((s) => {
        const Icon = GLYPHS[s.id];
        return (
          <a
            key={s.id}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            title={`${s.label} — ${s.handle}`}
            data-testid={`${testIdPrefix}-${s.id}`}
            className={`group ${px} rounded-full ${base} flex items-center justify-center transition-all hover:scale-110`}
            style={{ ["--hoverColor"]: s.color }}
          >
            <Icon size={iconSize} className="transition-colors group-hover:text-[var(--hoverColor)]" />
          </a>
        );
      })}
    </div>
  );
}
